import React, { use, useEffect, useState } from 'react';
import { SplitterOnChangeEvent, SplitterPaneProps } from '@progress/kendo-react-layout';
import { debounce } from 'lodash';
import CoreSplitter from '@components-clean/core/core-splitter';
import { RiskMonitoringContext } from '@pages-clean/risk-assessment/risk-monitoring/interfaces/context';
import ObservationChildAreas from '@pages-clean/risk-assessment/risk-monitoring/manage-observations/childArea/child-areas';
import ManageObservationsGrid from '@pages-clean/risk-assessment/risk-monitoring/manage-observations/manage-observations.grid';
import { SplitterOrientation } from '@utils/constants';

const ManageObservations = () => {
    const [panes, setPanes] = useState<SplitterPaneProps[]>([{ size: '50%', min: '15px' }, { min: '35px' }]);
    const onPaneChange = (event: SplitterOnChangeEvent) => {
        debounce(() => setPanes(event.newState), 20);
    };

    const { current, setCurrent } = use(RiskMonitoringContext);

    useEffect(() => {
        setCurrent({ ...current, selectedObservation: undefined, selectedObservationRisk: undefined });
        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
        // eslint-disable-next-line @eslint-react/exhaustive-deps
    }, []);

    return (
        <div style={{ height: 'calc(100% - 30px)' }}>
            <CoreSplitter
                className="!k-h-full"
                orientation={SplitterOrientation.vertical}
                data-testid="risk-monitoring-manage-observations-splitter"
                alignmentValues={panes}
                onChange={onPaneChange}
            >
                <div className="k-h-full">
                    <ManageObservationsGrid />
                </div>
                <div className="k-h-full">
                    <ObservationChildAreas />
                </div>
            </CoreSplitter>
        </div>
    );
};

export default ManageObservations;
